import Dinero from 'dinero.js';
import { CallApi, handleJSONResponse } from './common';
import { RoyaltiesAccount } from '@services/royalties/types/royalties-account';
import { AccountCreationRequest } from '@services/royalties/types/api/account-creation-request';
import { PayoutHistory } from '@services/royalties/types/payout-history';
import { AdminGetStatementResponse } from '@services/royalties/types/api/admin-get-statements-response';

const callAPI = CallApi('royalties');

export const get = async (): Promise<RoyaltiesAccount> => {
  const response = await callAPI(`/account`, 'GET');

  return handleJSONResponse(response);
};

export const register = async (code: string): Promise<RoyaltiesAccount> => {
  const payload: AccountCreationRequest = {
    code,
  };

  const response = await callAPI('/account', 'POST', payload);

  return handleJSONResponse(response);
};

export const remove = async (): Promise<RoyaltiesAccount> => {
  const response = await callAPI('/account', 'DELETE');

  return handleJSONResponse(response);
};

export const listPayouts = async (): Promise<PayoutHistory[]> => {
  const response = await callAPI('/payouts', 'GET');

  return handleJSONResponse(response);
};

export const getBalance = async (accountId?: string): Promise<Dinero.Dinero> => {
  const response = await callAPI(`/balance${accountId ? `/${accountId}` : ''}`, 'GET');

  const params: Dinero.DineroObject = await handleJSONResponse(response);

  return Dinero(params);
};

export const getStatements = async (accountId?: string): Promise<AdminGetStatementResponse> => {
  const response = await callAPI(`/statement${accountId ? `/${accountId}` : ''}`, 'GET');

  return handleJSONResponse(response);
};
